import {ElementRef} from '@angular/core';
import * as _ from 'lodash-es';

const VARIABLE_NAME_PREFIX = '--';
const VARIABLE_NAME_DOT_REPLACEMENT = '_';

export class TradingViewChartStyleVariablesAccessor {

    public computedStyle: CSSStyleDeclaration;

    private readonly variableNamespace = 'chart';

    constructor(
        private variablesHostElementRef: ElementRef
    ) {
        this.computedStyle = getComputedStyle(this.variablesHostElementRef.nativeElement as HTMLElement);
    }

    public getString(sectionPath: string, propertyPath: string): string {
        const variableName = this.buildStyleVariableName(sectionPath, propertyPath);

        // Trimming is required since the variable's value may starts from space: " rgba(25,25,25,0.8)"
        return _.trimStart(this.computedStyle.getPropertyValue(variableName));
    }

    public getMapOfStrings<K extends string>(sectionPath: string, keys: K[]): Record<K, string> {
        return keys.reduce((map, key) => {
            map[key] = this.getString(sectionPath, key);

            return map;
        }, {} as Record<K, string>);
    }

    private buildStyleVariableName(sectionPath: string, propertyPath: string): string {
        return _.compact([
            `${VARIABLE_NAME_PREFIX}${this.variableNamespace}`,
            sectionPath,
            propertyPath
        ])
            .join(VARIABLE_NAME_DOT_REPLACEMENT)
            .replace(/\./g, VARIABLE_NAME_DOT_REPLACEMENT);
    }

}
